import { alegacion } from "./alegacion";
import { fichajes_empleado_historial } from "./fichajes_empleado_historial";

export class alegacion_historico extends alegacion {
  public modificaciones_hist!: fichajes_empleado_historial;
  constructor(src?: any, enableTrackChanges: boolean = false) {
    super(src);
  }
}
